import React from 'react';
import ReactSelect from 'react-select';
import AsyncSelect from 'react-select/async';
import { connect } from 'react-redux';
import { withRouter } from '../../common/withRouter';
import DatePicker from 'react-datepicker';
import { Icon } from '../../web.common';
import { v4 as uuidv4 } from 'uuid';
import { getQueryStringParameters } from '../../common/utils';
import { makeDebouncer } from '../../common/makeDebouncer';

// TODO: reimplement with formik
export class FilterInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { update, data, name, className = '' } = this.props;
    return (
      <input
        className={className}
        style={{ width: '320px', display: 'inline-block', padding: '2px 5px', height: '38px' }}
        name={name}
        value={data[name]}
        onChange={event => update(name, event.target.value)}
      />
    );
  }
}

export class FilterCheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: uuidv4().toString()
    };
  }

  render() {
    const { update, data, name } = this.props;
    const { id } = this.state;
    const isChecked = data[name] === 'true';

    return (
      <React.Fragment>
        <input
          id={id}
          type='checkbox'
          className='filter-check'
          style={{ width: '320px', display: 'none', padding: '2px 5px', height: '38px', verticalAlign: 'middle' }}
          name={name}
          checked={isChecked}
          onChange={() => {
            const value = isChecked ? 'false' : 'true';
            return update(name, value);
          }}
        />
        <label className='filter-check-display' htmlFor={id}>
          <Icon className='true' iconName='check' />
        </label>
      </React.Fragment>
    );
  }
}

export class FilterSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { update, data, name, options, className = '' } = this.props;
    const defaultOption = {
      value: null,
      label: 'Any'
    };

    const currentOption = options.filter(x => x.value === data[name])[0] || defaultOption;

    return (
      <div style={{ width: '320px', display: 'inline-block' }} className={className}>
        <ReactSelect
          className='react-select-filters-section'
          classNamePrefix='react-select-filters-section-prefix'
          onChange={selection => {
            update(name, selection.value);
          }}
          value={currentOption}
          name={name}
          options={[defaultOption, ...options]}
        />
      </div>
    );
  }
}

function formatDate(d) {
 return [[d.getFullYear(), d.getMonth() + 1, d.getDate(),  ]
    .map(x => x.toString())
    .map(x => x.length < 2 ? "0" + x : x)
    .join('-'),
    'T',
  [d.getHours(), d.getMinutes(), d.getSeconds()]
    .map(x => x.toString())
    .map(x => x.length < 2 ? "0" + x : x)
    .join(':')].join('');
}

export const FilterTimePicker = props => {
  const { update, data, name } = props;
  const startDate = data[name] ? new Date(data[name]) : null;

  return (
    <DatePicker
      style={{ width: '320px', display: 'inline-block' }}
      selected={startDate}
      onChange={date => update(name, date ? formatDate(date) : '')}
      showTimeSelect
      timeFormat='HH:mm'
      timeIntervals={15}
      timeCaption='time'
      dateFormat='MMMM d, yyyy h:mm aa'
    />
  );
};


export class FilterSelectAsync extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.debouncer = makeDebouncer(500);
  }

  render() {
    const { update, data, name, loadOptions, className = '', debounce } = this.props;
    const defaultOption = {
      value: null,
      label: 'Any'
    };

    const currentSelection = data[name] ? {
      value: data[name],
      label: data[name]
    } : defaultOption;

    return (
      <div style={{ width: '320px', display: 'inline-block' }} className={className}>
        <AsyncSelect
          className='react-select-filters-section'
          classNamePrefix='react-select-filters-section-prefix'
          onChange={selection => {
            update(name, selection.value);
          }}
          defaultOptions={[{
            value: null,
            label: 'Any'
          }]}
          loadOptions={async key => (debounce
            ? this.debouncer(key, keyDebouncer => loadOptions(keyDebouncer))
            : loadOptions(key))}
          isMulti={false}
          value={currentSelection}
        />
      </div>
    );
  }
}

class FiltersBase extends React.Component {
  constructor(props) {
    super(props);
    const { location, initFromUrl, defaultValue = {} } = this.props;
    const search = location.search || '';

    // TODO consider to move whole paging responsability to filter component
    const data = initFromUrl
      ? Object.assign({}, defaultValue, getQueryStringParameters(search), { page: 1 })
      : Object.assign({}, defaultValue);

    this.state = {
      formData: data
    };
  }

  updateFormValue(key, value) {
    const { validateForm } = this.props;
    const { formData } = this.state;

    const updatedFormData = Object.assign({}, formData, {
      [key]: value
    });

    const validatedData = validateForm ? validateForm(updatedFormData, key) : updatedFormData;

    this.setState({ formData: validatedData });
  }

  render() {
    const { formData } = this.state;
    const { onSubmit, submitUrl, history, render } = this.props;

    return (
      <form
        onSubmit={event => {
          event.preventDefault();
          event.stopPropagation();

          if (onSubmit) {
            onSubmit(formData);
          }
          else if (submitUrl) {
            const parameters = Object.keys(formData)
              .filter(key => key && formData[key])
              .map(key => `${key}=${encodeURIComponent(formData[key])}`)
              .join('&');
            history.replace(`?${parameters}`);
          }
        }}
      >
        {
          render(formData, (key, value) => this.updateFormValue(key, value))
        }
      </form>
    );
  }
}


let FiltersInternal = withRouter(connect(({ isUnitTesting }) => ({ isUnitTesting }))(FiltersBase));

FiltersInternal.goToPage = (history, location, number, sortingBy,sortingDirection) => {
    // TODO consider to move responsability to filter component
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number,
        orderBy: sortingBy,
        orderDirection: sortingDirection
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

export const Filters = FiltersInternal;